import React, { useEffect, useMemo } from "react";
import { useLocation } from "react-router-dom";
import PageLayout from "../../public/pages/PageLayout";
import { getJwtRoleSlug } from "../../public/utils/jwtRole";
import { isOpenAppPath } from "../config/appScreenLockRegistry";
import { discardExpiredToken } from "../../public/api/httpClient";

const LOGOUT_BY_ROLE = {
  admin: "/admin-login",
  donor: "/donor-login",
  students: "/student-login",
};

export default function AppShellLayout() {
  const { pathname } = useLocation();
  const isOpenRoute = isOpenAppPath(pathname);

  const roleSlug = useMemo(() => {
    if (typeof localStorage === "undefined") return "";
    return getJwtRoleSlug(localStorage.getItem("jwt_token")) || "";
  }, [pathname]);

  useEffect(() => {
    /* Open screens allow anonymous access; only clear stale tokens when not signed in. */
    if (isOpenRoute && !roleSlug) discardExpiredToken();
  }, [isOpenRoute, pathname, roleSlug]);

  const logoutPath =
    LOGOUT_BY_ROLE[roleSlug] != null ? LOGOUT_BY_ROLE[roleSlug] : "/user-login";

  return (
    <PageLayout
      requiredRoleSlug={roleSlug || null}
      useDynamicNav={Boolean(roleSlug)}
      logoutPath={logoutPath}
    />
  );
}
